import React, { useEffect, useState } from "react"
import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import Select from 'react-select'
import { useSelector } from 'react-redux'

import DeleteModalModified from 'pages/parts/DeleteModalModified'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'

import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'
import { returnSign, findKeyFromArrayByValue, formatMoney, copyText } from 'helpers/helpers'

function Index() {
	const { t } = useTranslation()

	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [poses, setPoses] = useState([])
	const [users, setUsers] = useState([])
	const [menu, setMenu] = useState([])
	const [userRoles, setUserRoles] = useState([])
	const [bonusTypes, setBonusTypes] = useState([])
	const [products, setProducts] = useState([])
	const [showModal, setShowModal] = useState(false)
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const initialFilterData = { pos_id: reduxAccount.pos_id, search: '' }
	const initialPagination = { url: '', response: null }
	const {
		filterData,
		appliedFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		patchFilterData,
		applySearch,
		applyFilters,
		paginate,
		resetFilters,
	} = useFilterSearchPagination({ initialFilterData, initialPagination })
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0, bool: false })

	async function searchWithFilter(customFilterData = filterData) {
		var filterUrl = "/employee-bonus"
		var urlParams = ""
		checkFilter()

		if (customFilterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + customFilterData.pos_id
		if (customFilterData.role)
			urlParams += returnSign(urlParams) + 'role=' + customFilterData.role
		if (customFilterData.search)
			urlParams += returnSign(urlParams) + 'search=' + customFilterData.search
		if (customFilterData.page)
			urlParams += returnSign(urlParams) + 'page=' + customFilterData.page

		if (`/employee-bonus${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}

		setDropdownIsOpen(false)
	}

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (selectedItem.id) {
			response = await PUT('/employee-bonus', selectedItem, { loader: true })
		} else {
			response = await POST('/employee-bonus', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			toggleModal()
			searchWithFilter()
			setSelectedItem({})
		}
	}

	function handleChildChange(key, value, index) {
		var selectedItemCopy = { ...selectedItem }

		selectedItemCopy.items[index][key] = value

		if (selectedItemCopy.employee_bonus_type_id === 3 && key === 'bonus')
			selectedItemCopy.items[index]['bonus_fixed'] = ''
		if (selectedItemCopy.employee_bonus_type_id === 3 && key === 'bonus_fixed')
			selectedItemCopy.items[index]['bonus'] = ''

		setSelectedItem(selectedItemCopy)
	}

	function addToList() {
		var selectedItemCopy = { ...selectedItem }
		var child = {
			'menu_id': '',
			'bonus': '',
			'pos_id': selectedItemCopy.pos_id,
		}

		selectedItemCopy.items.push(child)
		setSelectedItem(selectedItemCopy)
	}

	function deleteItem(index) {
		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy.items.splice(index, 1)

		setSelectedItem(selectedItemCopy)
	}

	async function deleteFromDB() {
		const response = await DELETE(`/employee-bonus`, {
			'id': deleteModalParams.id
		}, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			setDeleteModalParams({ id: 0, index: 0, bool: false })
		}
	}

	async function toggleModal(bool = false, item = { 'items': [] }) {
		if (bool) {
			var response = await GET(`/employee-bonus-users`, {}, { loader: true })
			if (httpOk(response)) setUsers(response.data)

			if (products.length === 0) {
				response = await GET(`/helper/products`, {}, { loader: true })
				if (httpOk(response)) setProducts(response.data)
			}


			if (menu.length === 0) {
				response = await GET(`/helper/menu`, {}, { loader: true })
				if (httpOk(response)) setMenu(response.data)
			}
		}

		setShowModal(bool)
		setSelectedItem(item)
	}

	function resetFilter() {
		resetFilters({ ...initialFilterData }, searchWithFilter)
	}

	function checkFilter() {
		if (
			filterData.pos_id === null &&
			filterData.search === ''
		) {
			// managed by hook when filters are reset
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function handlePaginate(page) {
		const nextFilterData = { ...filterData, page }
		paginate(page)
		searchWithFilter(nextFilterData)
	}

	async function getEmployeeBonusTypes() {
		const response = await GET('/helper/employee-bonus-types')
		if (httpOk(response)) setBonusTypes(response.data)
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	async function getUsersRoles() {
		const response = await GET('/helper/user-roles')
		if (httpOk(response)) setUserRoles(response.data)
	}

	useEffect(() => {
		getPoses()
		getUsersRoles()
		getEmployeeBonusTypes()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					KPI [{data?.total}]
				</h4>
				<div className="d-flex gap-2">
					{/* почасовая/подённая оплата уехала из KPI в отдельный раздел с историей ставок */}
					<Link className="btn-rounded btn btn-outline-primary vertical-center" to="/employee-time-rates">
						{t('time_rates')}
					</Link>
					<button className="btn-rounded btn btn-primary" onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex gap-2 mb-3">
						<div>
							<FilterSearch
								value={filterData.search}
								onSearchChange={(search) => applySearch(search, searchWithFilter)}>
							</FilterSearch>
						</div>
						<div>
							<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
								<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
									{t('filter')}
								</Dropdown.Toggle>

								<Dropdown.Menu className="dropdown-filter">
									<div className="row">
										<div className="form-group col-md-6">
											<label>{t('pos')}</label>
											<Select
												options={poses}
												value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => patchFilterData({ 'pos_id': option.id })}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
										<div className="form-group col-md-6">
											<label>{t('roles')}</label>
											<Select
												options={userRoles}
												value={userRoles.find(option => option.role === filterData.role) || ''}
													onChange={(option) => patchFilterData({ 'role': option.role })}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.role}
											/>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-md-12">
											<div className="d-flex justify-content-end">
												<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
												<button className="btn btn-primary" onClick={() => applyFilters(searchWithFilter)}>{t('apply')}</button>
											</div>
										</div>
									</div>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{appliedFilterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b> {findKeyFromArrayByValue(poses, 'id', appliedFilterData.pos_id, 'name')}
									</span>
								}
								{appliedFilterData.role_id &&
									<span className="me-2">
										<b>{t('role')}: </b> {findKeyFromArrayByValue(userRoles, 'role', appliedFilterData.role, 'name')}
									</span>
								}
								{appliedFilterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{appliedFilterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '15%' }}>{t('pos')}</th>
									<th style={{ 'width': '15%' }}>{t('user')}</th>
									<th style={{ 'width': '10%' }}>{t('role')}</th>
									<th style={{ 'width': '10%' }}>{t('position')}</th>
									<th style={{ 'width': '15%' }}>{t('type')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('bonus')}</th>
									<th style={{ 'width': '35%' }} ></th>
									<th style={{ 'width': '33px', 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="td-ellipsis">{item.pos_name}</td>
										<td className="td-ellipsis"
											onClick={() => copyText(item.user_login)}>
											{item.first_name}
										</td>
										<td className="td-ellipsis"
											onClick={() => copyText(item.user_login)}>
											{item.role_name}
										</td>
										<td className="td-ellipsis">
											{item.position_name}
										</td>
										<td className="td-ellipsis">{item.bonus_type_name}</td>
										<td className="text-end">
											{item.bonus > 0 &&
												<span>{formatMoney(item.bonus, 2)}</span>
											}
											{item.bonus_fixed > 0 &&
												<span>{formatMoney(item.bonus_fixed, 2)}</span>
											}
										</td>
										<td></td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item" onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														<div className="table-dropdown-item text-danger"
															onClick={() => setDeleteModalParams({ id: item.id, index: index, bool: true })}>
															<i className="uil-times"></i>
															{t('delete')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={handlePaginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => toggleModal()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{selectedItem.id ?
							<>{t('edit')}</>
							:
							<>{t('create')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('user')}<span className="required-mark">*</span></label>
							<Select
								options={users}
								value={users.find(option => option.login === selectedItem.user_login)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'user_login': option.login })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.full_name}
								getOptionValue={(option) => option.login}
							/>
						</div>
						<div className="form-group">
							<label>{t('type')}<span className="required-mark">*</span></label>
							<Select
								options={bonusTypes}
								value={bonusTypes.find(option => option.id === selectedItem.employee_bonus_type_id) || ''}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'employee_bonus_type_id': option.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						{selectedItem.employee_bonus_type_id === 2 &&
							<>
								<div className="d-flex gap-2">
									<div className="form-group w-100">
										<label>{t('percentage')}</label>
										<input type="number" className="form-control" name="bonus"
											value={selectedItem.bonus}
											onChange={(e) => setSelectedItem({
												...selectedItem,
												'bonus': e.target.value,
												'bonus_fixed': '',
											})} />
									</div>
									<div className="form-group w-100">
										<label>{t('amount')}</label>
										<input type="number" className="form-control" name="bonus_fixed"
											value={selectedItem.bonus_fixed}
											onChange={(e) => setSelectedItem({
												...selectedItem,
												'bonus': '',
												'bonus_fixed': e.target.value
											})} />
									</div>
								</div>
							</>
						}

						{selectedItem.employee_bonus_type_id === 1 &&
							<>
								<div className="d-flex justify-content-between my-3">
									<div className="vertical-center">
										<h5><b>{t('menu')}</b></h5>
									</div>
									<div className="d-flex justify-content-center">
										<div className="table-action-button table-action-primary-button"
											onClick={() => addToList()}>
											<i className="uil-plus"></i>
										</div>
									</div>
								</div>

								<div className="table-responsive">
									<table className="table table-bordered mb-0">
										<thead>
											<tr>
												<th style={{ 'width': '80%' }}>{t('menu')}</th>
												<th style={{ 'width': '20%' }}>{t('percentage')}</th>
												<th style={{ 'minWidth': '33px' }}></th>
											</tr>
										</thead>
										<tbody>
											{selectedItem?.items?.map((item, index) => (
												<tr key={index}>
													<td className="w-75">
														<div className="w-100">
															<Select
																menuPosition="fixed"
																value={menu.find(option => option.id === selectedItem?.items[index]['menu_id']) || ''}
																options={menu}
																onChange={(option) => handleChildChange('menu_id', option.id, index)}
																placeholder=""
																noOptionsMessage={() => t('list_empty')}
																getOptionLabel={(option) => option.name}
																getOptionValue={(option) => option.id}
															/>
														</div>
													</td>
													<td className="w-25">
														<div>
															<input type="number" className="form-control" name="bonus"
																value={item.bonus}
																onChange={(e) => handleChildChange('bonus', e.target.value, index)} />
														</div>
													</td>
													<td className="vertical-middle">
														<div className="d-flex justify-content-center">
															<div className="table-action-button table-action-danger-button"
																onClick={() => deleteItem(index)}>
																<i className="uil uil-times"></i>
															</div>
														</div>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</>
						}

						{(selectedItem.employee_bonus_type_id === 3 || selectedItem.employee_bonus_type_id === 5) &&
							<>
								<div className="d-flex justify-content-between my-3">
									<div className="vertical-center">
										<h5><b>{t('products')}</b></h5>
									</div>
									<div className="d-flex justify-content-center">
										<div className="table-action-button table-action-primary-button"
											onClick={() => addToList()}>
											<i className="uil-plus"></i>
										</div>
									</div>
								</div>

								<div className="table-responsive">
									<table className="table table-bordered mb-0">
										<thead>
											<tr>
												<th style={{ 'width': '60%' }}>{t('product')}</th>
												<th style={{ 'width': '20%' }}>{t('percentage')}</th>
												<th style={{ 'width': '20%' }}>{t('amount')}</th>
												<th style={{ 'minWidth': '33px' }}></th>
											</tr>
										</thead>
										<tbody>
											{selectedItem?.items.map((item, index) => (
												<tr key={index}>
													<td className="w-50">
														<div className="w-100">
															<Select
																menuPosition="fixed"
																value={products.find(option => option.id === selectedItem?.items[index]['product_id']) || ''}
																options={products}
																onChange={(option) => handleChildChange('product_id', option.id, index)}
																placeholder=""
																noOptionsMessage={() => t('list_empty')}
																getOptionLabel={(option) => option.name}
																getOptionValue={(option) => option.id}
															/>
														</div>
													</td>
													<td className="w-25">
														<div>
															<input type="number" className="form-control" name="bonus"
																value={item.bonus}
																onChange={(e) => handleChildChange('bonus', e.target.value, index)} />
														</div>
													</td>
													<td className="w-25">
														<div>
															<input type="number" className="form-control" name="bonus_fixed"
																value={item.bonus_fixed}
																onChange={(e) => handleChildChange('bonus_fixed', e.target.value, index)} />
														</div>
													</td>
													<td className="vertical-middle">
														<div className="d-flex justify-content-center">
															<div className="table-action-button table-action-danger-button"
																onClick={() => deleteItem(index)}>
																<i className="uil uil-times"></i>
															</div>
														</div>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</>
						}

						{/* типы «по смене/посещение [часы|дни]» переехали в раздел «Оплата по времени» */}

						<div className="d-flex gap-3 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

			<DeleteModalModified
				deleteModalParams={deleteModalParams}
				setDeleteModalParams={setDeleteModalParams}
				deleteFromDB={deleteFromDB}>
			</DeleteModalModified>
		</>
	)
}

export default Index